const tools = {
	is_array : function  (obj){
		return Array.isArray(obj);
	},
	in_array: function  (obj,val){
		if (!this.is_array(obj)){
			return -1;
		}
		let key = obj.indexOf(val);
		return key
	},
	unset : function  (obj,key){
		obj.splice(key,1);
		return obj;
	},
};
export default tools;
